<table class="legend-table" data-ui-name="Results legend table" data-ui-component="results-legend" data-testid="results-legend-results-legend-table">
    <th (click)="toggleLegendExpand()" data-ui-name="Tr results legend title" data-ui-component="results-legend" data-testid="results-legend-tr-results-legend-title">
        <div>
            <div style="visibility:hidden; width: auto">
                <i *ngIf="!isExpanded" class="fas fa-chevron-right legend-arrow"></i>
                <i *ngIf="isExpanded" class="fas fa-chevron-down legend-arrow"></i>
            </div>
            <span><tra slug="tr_results_legend_title"></tra></span>
            <i *ngIf="!isExpanded" class="fas fa-chevron-right legend-arrow"></i>
            <i *ngIf="isExpanded" class="fas fa-chevron-down legend-arrow"></i>
        </div>
    </th>
    <ng-container *ngIf="isExpanded">
        <tr data-ui-name="Tr results legend check values row" data-ui-component="results-legend" data-testid="results-legend-tr-results-legend-check-values-row">
            <td>
                <div>
                    <i class="fas fa-check-circle fa-fw" style="color: #0080FF;"></i>
                    <span><tra slug="tr_results_legend_check"></tra></span>
                </div>
            </td>
        </tr>
        <tr data-ui-name="Tr results legend circle values row" data-ui-component="results-legend" data-testid="results-legend-tr-results-legend-circle-values-row">
            <td>
                <div>
                    <i class="far fa-dot-circle fa-fw" style="color: #0080FF;"></i>
                    <span><tra slug="tr_results_legend_circle"></tra></span>
                </div>
            </td>
        </tr>
        <tr *ngIf="numCRQuestions" data-ui-name="Tr results legend keyboard values row" data-ui-component="results-legend" data-testid="results-legend-tr-results-legend-keyboard-values-row">
            <td>
                <div>
                    <i class="fas fa-keyboard fa-fw" style="color: #fcbc14;"></i>
                    <span><tra slug="tr_results_legend_keyboard"></tra></span>
                </div>
            </td>
        </tr>
    </ng-container>
</table>